import { createStructuredSelector, createSelector } from 'reselect';

export const bffDomain = () => state => state.Data;

const globalLoaderDomain = () => state => state.root.globalLoader;

export const translationsSelector = state => state.Data.translations;

const selectShowLoader = createSelector(
  globalLoaderDomain(),
  substate => substate.show
);

export const selectLocale = createSelector(
  bffDomain(),
  ({ locale }) => locale || 'en_US'
);

export const selectCsrfToken = createSelector(
  bffDomain(),
  subState => subState.csrfToken
);

export const selectMetadata = createSelector(
  bffDomain(),
  subState => subState.metadata || {}
);

export const selectTeslaSupportEmail = createSelector(
  bffDomain(),
  subState => subState.supportEmail || 'EU-customerhappiness@tesla.com'
);

export default createStructuredSelector({
  translations: translationsSelector,
  showLoader: selectShowLoader,
  locale: selectLocale,
  csrfToken: selectCsrfToken,
  metadata: selectMetadata,
  teslaSupportEmail: selectTeslaSupportEmail,
});
